(function () {
  const sliderEl = document.querySelector(".js-media-list");

  if (!sliderEl) return;

  const subSliderEl = document.querySelector(".js-media-sublist");

  const desktopType = sliderEl.dataset?.desktopType || "slider";
  const mobileType = sliderEl.dataset?.mobileType || "true";

  if (desktopType === "thumbs_aside") {
    function swiperInit() {
      subSliderInit(true);
      sliderInit(true);
      popupSubSliderInit(true);
      popupSliderInit(true);
    }

    document.addEventListener("shopify:section:load", function (e) {
      swiperInit();
    });

    if (!window?.isSwiperInit) {
      swiperInit();
    }

    window.isSwiperInit = true;
  } else {
    function swiperInit() {
      subSliderInit(true);
      sliderInit(true);
    }

    function popupswiperInit() {
      popupSubSliderInit(true);
      popupSliderInit(true);
    }

    if (!sliderEl) return;

    let wasMobile = window.innerWidth < 990;

    function swiperDestroy() {
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      if (subSliderEl.swiper) {
        subSliderEl.swiper.destroy(true, true);
      }
    }

    function checkSwiper() {
      const isMobile = window.innerWidth < 990;

      if (mobileType && isMobile && !window.isSwiperInit) {
        swiperInit();
        window.isSwiperInit = true;
      }

      if (!isMobile) {
        window.isSwiperInit = false;
      }

      wasMobile = isMobile;
    }

    document.addEventListener("shopify:section:load", function () {
      checkSwiper();
      popupswiperInit();
    });

    checkSwiper();

    window.addEventListener("resize", function () {
      const isMobile = window.innerWidth < 990;

      if (isMobile !== wasMobile) {
        checkSwiper();
      }

      if (!isMobile && desktopType != "thumbs_aside") {
        swiperDestroy();
      }
    });

    if (!window?.isPopSwiperInit) {
      popupswiperInit();
    }

    window.isPopSwiperInit = true;
  }
})();
